import React from "react";
import "./Label.css";

const SCLabel = (props) => {
    return (
        <span {...props} className={`sc-label ${props.className || ''}`}>{props.children}</span>
    );
}

export default SCLabel;